module.exports = __webpack_public_path__ + "static/food-package-df92e452bca39e072fefa510f3547e14.png";